import React, { useState } from "react";
import {Link, useNavigate} from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import emailjs from "emailjs-com";
import {Button} from "rsuite";

const SUPPORT_EMAILS = (process.env.REACT_APP_SUPPORT_EMAILS || "")
  .split(",")
  .map((e) => e.trim())
  .filter(Boolean);

const ForgotPassword = () => {
  const [formData, setFormData] = useState({ email: "" });
  const [isSending, setIsSending] = useState(false);
  const [sent, setSent] = useState(false);
  const navigator = useNavigate();


  const onSubmit = async (event) => {
    event.preventDefault();
    if (!formData.email) {
      toast.error("Please enter your email.");
      return;
    }
    if (SUPPORT_EMAILS.length === 0) {
      toast.error("Support contacts are not configured.");
      return;
    }

    setIsSending(true);
    try {
      await Promise.all(
        SUPPORT_EMAILS.map((recipient) =>
          emailjs.send(
            "service_vfofqtm",
            "template_v83hcrk",
            {
              recepient_email: recipient,
              reset_email: formData.email,
            },
            "Rlk8panFMyjDbj0k9"
          )
        )
      );
      setSent(true);
    } catch (error) {
      console.error("Failed to send password reset request:", error);
      toast.error("Failed to send request. Please try again.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="col-12 col-md-8 col-lg-12 row  d-flex justify-content-center">
      <div className="col-md-5 bg-white box-shadow-login m-0">
        <div className="d-flex justify-content-center align-items-center mb-3">
          <h3>Forgot Password</h3>
        </div>

        {sent ? (
          <div className="text-center">
            <p>
              Your password reset request has been sent to our support team.
              You will be contacted shortly.
            </p>
            <div className="d-grid">
              <Button onClick={() => navigator("/")} className="btn btn-primary-new">
                  Back to Home
              </Button>
            </div>
          </div>
        ) : (
          <form onSubmit={onSubmit}>
            <p className="gray-text mb-3">
              Enter your email and our support team will reset your password.
            </p>
            <div
              className="mb-3 position-relative input-wrapper"
              onFocus={(event) => {
                event.currentTarget.classList.add("focused");
              }}
              onBlur={(event) => {
                event.currentTarget.classList.remove("focused");
              }}
            >
              <input
                type="email"
                className="form-control"
                placeholder="Enter email"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                required
              />
            </div>
            <div className="d-grid">
              <button
                type="submit"
                className="btn btn-primary-new"
                disabled={isSending}
              >
                {isSending ? "Sending..." : "Send Request"}
              </button>
            </div>
          </form>
        )}
      </div>
      <ToastContainer />
    </div>
  );
};

export default ForgotPassword;
